import { render, staticRenderFns } from "./PackageNameBatchEdit.vue?vue&type=template&id=682c93e2&scoped=true"
import script from "./PackageNameBatchEdit.vue?vue&type=script&lang=js"
export * from "./PackageNameBatchEdit.vue?vue&type=script&lang=js"
import style0 from "./PackageNameBatchEdit.vue?vue&type=style&index=0&id=682c93e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682c93e2",
  null
  
)

export default component.exports